import { createFileRoute } from "@tanstack/react-router";
import MentalHealthTreatmentForFirstResponders from "@/pages/MentalHealthTreatmentForFirstResponders";
export const Route = createFileRoute(
  "/mental-health-treatment-for-first-responders",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Mental Health Treatment For First Responders | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Mental health treatment for first responders in Coral Springs, FL. TMS, SAINT TMS, and therapy for depression, PTSD, and occupational stress.",
        },
        {
          property: "og:title",
          content:
            "Mental Health Treatment For First Responders | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Mental health treatment for first responders in Coral Springs, FL. TMS, SAINT TMS, and therapy for depression, PTSD, and occupational stress.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/mental-health-treatment-for-first-responders",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/mental-health-treatment-for-first-responders",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <MentalHealthTreatmentForFirstResponders />;
}
